import { tabToName } from "@utils/utils";
import React from "react";

import { Button, TabNavigation } from "@fronterahealth/frontera-ui-components";

import { useAdminData } from "@providers/AdminDataProvider";
import { useVideoSessionData, videoSessionNavigationTabType } from "@providers/VideoSessionProviderV2";

interface VideoSideBarProps {
  currentTime: number;
}

export const VideoSideBarV2: React.FC<VideoSideBarProps> = () => {
  const { selectedTab, setSelectedTab } = useVideoSessionData();
  const { isUserRBT, isUserCaregiver } = useAdminData();

  const videoSideBarNavigationTabs: videoSessionNavigationTabType[] = ["activity", "summary", "moments", "transcript"];

  const userTabs: readonly videoSessionNavigationTabType[] =
    isUserRBT || isUserCaregiver ? ["activity"] : videoSideBarNavigationTabs;
  return (
    <div
      className={`min-w-full max-w-[calc(100%)] no-scrollbar overflow-x-scroll ${isUserRBT ? "justify-items-center border-b" : ""}  border-gray-200`}
    >
      <TabNavigation
        edgeToEdge
        tabs={userTabs.map((tab) => ({
          current: selectedTab === tab,
          type: "component",
          name: tab,
          Component: (
            <Button
              text={<div className="w-full flex font-normal flex-row justify-center gap-2">{tabToName(tab)}</div>}
              appearance="text"
              className={`hover:text-primary ${selectedTab === tab ? "text-limestone-900" : "text-text-secondary"}`}
              onClick={() => setSelectedTab(tab)}
            />
          ),
        }))}
      />
    </div>
  );
};
